"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _styles = require("@material-ui/core/styles");

var _elements = require("../../elements");

var _Alert = _interopRequireDefault(require("./icons/Alert.js"));

var _Error = _interopRequireDefault(require("./icons/Error.js"));

var _Warning = _interopRequireDefault(require("./icons/Warning.js"));

var _Alert2 = _interopRequireDefault(require("./Alert.css"));

var _utils = require("../../utils");

var Alert =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Alert, _React$PureComponent);

  function Alert() {
    (0, _classCallCheck2.default)(this, Alert);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Alert).apply(this, arguments));
  }

  (0, _createClass2.default)(Alert, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          open = _this$props.open,
          onDismiss = _this$props.onDismiss,
          title = _this$props.title,
          buttonText = _this$props.buttonText,
          classes = _this$props.classes;
      return React.createElement(_Dialog.default, {
        open: open,
        onClose: onDismiss,
        PaperProps: {
          classes: {
            root: classes.root
          }
        },
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        disableBackdropClick: true,
        disableEscapeKeyDown: true
      }, React.createElement("div", {
        className: classes.dialogIcon
      }, this.dialogIcon), React.createElement(_DialogTitle.default, {
        id: "alert-dialog-title",
        className: classes.title
      }, (0, _utils.isTextContent)(title) ? React.createElement(_elements.Typography, {
        variant: 'dialogHeader'
      }, title) : title), React.createElement(_DialogContent.default, {
        className: classes.content
      }, (0, _utils.isTextContent)(children) ? React.createElement(_elements.Typography, {
        variant: 'dialogContent',
        id: "alert-dialog-description"
      }, children) : children), React.createElement(_DialogActions.default, {
        className: classes.actions
      }, React.createElement(_elements.Button, {
        onClick: onDismiss,
        type: "primary"
      }, buttonText)));
    }
  }, {
    key: "dialogIcon",
    get: function get() {
      switch (this.props.type) {
        case 'error':
          return React.createElement(_Error.default, null);

        case 'warning':
          return React.createElement(_Warning.default, null);

        default:
          return React.createElement(_Alert.default, null);
      }
    }
  }]);
  return Alert;
}(React.PureComponent);

Alert.defaultProps = {
  buttonText: 'Dismiss',
  type: 'info'
};
Alert.propTypes = {
  /**
   * If true, the Alert is open.
   */
  open: PropTypes.bool.isRequired,

  /**
   * Callback fired when the component requests to be closed.
   */
  onDismiss: PropTypes.func.isRequired,

  /**
   * Header of the Alert
   */
  title: PropTypes.node.isRequired,

  /**
   * Content of the Alert
   */
  children: PropTypes.node.isRequired,

  /**
   * Dismiss button text
   */
  buttonText: PropTypes.node,

  /**
   * Alert icon type
   */
  type: PropTypes.oneOf(['error', 'warning', 'info'])
};

var _default = (0, _styles.withStyles)(_Alert2.default)(Alert);

exports.default = _default;